import styled from 'styled-components'

/**
 * Injects the styles of a styled component into another react component
 * The second argument will not be rendered, but passes its styled-component
 * class names onto the first argument, which is rendered. If the first
 * component is not styled with styled-components, the styles of the second
 * argument will overrule styles of the first with equal specificity. If
 * both are styled components, precidance is given to the component defined
 * last.
 * 
 * Returns incomplete component, MUST be styled with backticks
 * Example of appropriate use:
 * styleableComposition(MyComponent, MyStyledComponent)`
 *   // css goes here
 * `
 * NOT: styleableComposition(MyComponent, MyStyledComponent);
 * 
 * Note: cannot be used with the "as" polymorphic prop
 */
export const styleableComposition = (Component, StyledComponent) => styled(StyledComponent).attrs({ as: Component })


/**
 * Injects the styles of a styled component into another react component
 * The second argument will not be rendered, but passes its styled-component
 * class names onto the first argument, which is rendered. If the first
 * argument is not styled with styled-components, the styles of the second
 * argument will overrule styles of the first with equal specificity. If
 * both are styled components, precidance is given to the component defined
 * last.
 * 
 * @returns a complete component, to add additional stying you must use styled()
 * 
 * Note: cannot be used with the "as" polymorphic prop
 */
export const styledComposition = (Component, StyledComponent) => styleableComposition(Component, StyledComponent)``


/**
 * Returns the given styled component, or a default or div if component is null/undefined
 * Intended for components that get used in multiple places with different typographies passed as props
 * 
 * styleComponent: a component to use (usually a styled-component from typgoraphy.js)
 * defaultComponent: if given, will be used as default instead of div
 * ignoreDefault: if true, use a div instead of the default (useful when you want to allow a passed css class to override the default)
 */
export const optionallyStyled = (styleComponent, defaultComponent, ignoreDefault) => {
  if (styleComponent) return styleComponent
  else if (defaultComponent && !ignoreDefault) return defaultComponent
  else return 'div'
}

export const optionalStyledComposition = (Component, StyledComponent) => (
  StyledComponent ? styledComposition(Component, StyledComponent) : Component
)
